import axios from '../axios';

const leaveProject = async (projectId: string) => {
  const { data } = await axios.delete(`/projects/${projectId}/leave`);

  return data;
};

export default leaveProject;
